import Header from '../../../Components/Header/Header';
import styles from './services.module.scss';
import { Helmet } from 'react-helmet-async';
import useInView from '../../../Components/UseInView/useInView';
import Cta from '../../../Components/Cta/Cta';
import Footer from '../../../Components/Footer/Footer';
import serviceList from '../../../Data/Services.json';
import ServiceDescriptionCard from '../../../Components/ServiceDescriptionCard/ServiceDescriprionCard';

const Services = () => {
    const [servicesLandingRef, servicesLandingVisible] = useInView();

    let ServiceRender = serviceList.map((service) => {
        return (
            <ServiceDescriptionCard
                key={service.id}
                id={service.id}
                title={service.title}
                briefDescription={service.briefDescription}
                fullDescription={service.fullDescription}
                icon={service.path}
                image={service.image}
            />
        );
    });

    return (
        <>
            <Helmet>
                <title>Clear Property Management - Property Management Services</title>
                <meta name='description' content='We provide property management services.' />
                <link rel='canonical' href='/' />
            </Helmet>
            <Header />

            <p>[Our Services]</p>
            <h1>OUR SERVICES</h1>

            <div
                id='Properties Landing'
                ref={servicesLandingRef}
                className={`${styles.serviceWrapper} ${servicesLandingVisible ? styles.visible : ''}`}
            >
                {ServiceRender}
            </div>

            <div id='Cta' className={`${styles.sectionContainer} ${styles.visible}`}>
                <Cta />
            </div>

            <Footer />
        </>
    );
};

export default Services;
